// extracted by mini-css-extract-plugin
module.exports = {"File__container":"File__container__3SGky","File__closePartial":"File__closePartial__3ovj1","File__thumbnail":"File__thumbnail__3-opY"};